import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OrgJed } from 'src/app/lookups/orgjed/orgjed';
import { TabsContainerService, BaseTabsContainer, UserService, BaseDataService, QueryParameter, TableContextMenuItem } from 'yt-ng-framework';

@Component({
  selector: 'app-sist-radnih-mesta-tabs',
  templateUrl: './sist-radnih-mesta-tabs.component.html'
})
export class SistRadnihMestaTabsComponent
extends BaseTabsContainer<OrgJed>
implements OnInit {

  constructor(
    public tabsContainerService: TabsContainerService<OrgJed>,
    protected activatedRoute: ActivatedRoute,
    protected userService: UserService,
    protected baseDataService: BaseDataService 
  ) {
    super(tabsContainerService, activatedRoute, userService);

   }

  ngOnInit() {
    super.ngOnInit();
  }

}
